import SoundManager from "../../../../../../../lib/html5-software-library/src/ranj/audio/SoundManager";
import RevisableLanguagePack from "../../../../../../../lib/html5-software-library/src/ranj/language/RevisableLanguagePack";
import LayoutManager from "../../../../../../../lib/html5-software-library/src/ranj/layout/LayoutManager";
import ClickEaterFactory from "../../../../../core/ui/ClickEaterFactory";
import EmailAddedEvent from "../../../../email/model/EmailAddedEvent";
import EmailConversationStatusChangedEvent from "../../../../email/model/EmailConversationStatusChangedEvent";
import EmailModel from "../../../../email/model/EmailModel";
import FileModelEvent from "../../../../files/event/FileModelEvent";
import FileModel from "../../../../files/model/FileModel";
import LaptopSkinKeyRegistry from "../../../model/LaptopSkinKeyRegistry";
import LaptopSoundType from "../../../sound/LaptopSoundType";
import AbstractLaptopMediator from "../../AbstractLaptopMediator";

export default class LaptopMainScreenMediator extends AbstractLaptopMediator {
    /**
     * @constructor
     * @param {createjs.MovieClip} target 
     * @param {soma.EventDispatcher} dispatcher 
     * @param {LayoutManager} layoutManager 
     * @param {ClickEaterFactory} clickEaterFactory 
     * @param {SoundManager} soundManager 
     * @param {EmailModel} emailModel 
     * @param {FileModel} fileModel 
     * @param {RevisableLanguagePack} languagePack 
     */
    constructor(target, dispatcher, layoutManager, clickEaterFactory, soundManager, emailModel, fileModel, languagePack) {
        super(target, dispatcher, layoutManager, clickEaterFactory);

        this._soundManager = soundManager;
        this._emailModel = emailModel;
        this._fileModel = fileModel;
        this._languagePack = languagePack;
    }

    initialize() {
        super.initialize();

        this.registerEventListener(EmailAddedEvent.EMAIL_ADDED_TO_CONVERSATION, this.updateIndicators.bind(this));
        this.registerEventListener(EmailConversationStatusChangedEvent.STATUS_CHANGED, this.updateIndicators.bind(this));
        this.registerEventListener(FileModelEvent.FILE_ADDED, this.updateIndicators.bind(this));

        this.initializeButtons();
        this.updateIndicators();
    }

    destroy() {
        super.destroy();
    }

    initializeButtons() {
        if (this._target.emailButton) {
            this.createButton(this._target.emailButton, _ => {
                this.gotoScreen(LaptopSkinKeyRegistry.LAPTOP_EMAIL_SCREEN_SKIN);
            }, this._languagePack.getText('laptop.mainScreen.apps.emailAppLabel'), LaptopSoundType.CLICK);
        }

        if (this._target.fileButton) {
            this.createButton(this._target.fileButton, _ => {
                this.gotoScreen(LaptopSkinKeyRegistry.LAPTOP_FILE_EXPLORER_SCREEN_SKIN);
            }, this._languagePack.getText('laptop.mainScreen.apps.fileExplorerAppLabel'), LaptopSoundType.CLICK);
        }
    }

    updateIndicators() {
        if (this._target.emailButton) {
            const unreadCount = this._emailModel.getUnreadCount();
            const unreadCountString = unreadCount.toString();
            this._target.emailButton.newIndicator.gotoAndStop(unreadCountString.length > 1 ? 1 : 0);
            this._target.emailButton.newIndicator.textField.text = unreadCountString;
            this._target.emailButton.newIndicator.visible = unreadCount > 0;
        }

        if (this._target.fileButton) {
            const unreadCount = this._fileModel.newFileCount;
            const unreadCountString = unreadCount.toString();
            this._target.fileButton.newIndicator.gotoAndStop(unreadCountString.length > 1 ? 1 : 0);
            this._target.fileButton.newIndicator.textField.text = unreadCountString;
            this._target.fileButton.newIndicator.visible = unreadCount > 0;
        }
    }
}